import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    currentBag: ''
  },
  getters: {
    getCurrentBag: state => state.currentBag
  },
  mutations: {
    setCurrentBag(state, bag) {
      state.currentBag = bag
    }
  }
})

const storeContext = require.context('@/store/modules', true, /\.js$/)

storeContext.keys().forEach(modules => {
  store.registerModule(
    modules.replace(/(^\.\/)|(\.js$)/g, ''),
    storeContext(modules).default
  )
})

Vue.prototype.$store = store
export default store
